export class GenericMessage {
    constructor(raw) {
        this.raw = raw;
    }
    set(key, value) {
        this.raw[key] = value;
        return this;
    }
    send() {
        var _a;
        var host = (_a = window.opener) !== null && _a !== void 0 ? _a : ((window.parent !== window) ? window.parent : null);
        let message = { type: "GIS", ...this.raw };
        if (host)
            host.postMessage(message, window.location.origin);
    }
}
